export const getDefaultReportParametersDisplay = () => ({
  isTeacherOrSchoolAdministratorTypeDisplayed: false,
  isRefinementOrReinforcementTypeDisplayed: false,
  isEvaluatorCertificationTypeDisplayed: false,
  isTeacherOverallAverageTypeDisplayed: false,
  isRoundingTypeDisplayed: false,
  isOrganizationDisplayed: false,
  isDistrictDisplayed: false,
  isDistrictMultiSelectDisplayed: false,
  isSchoolDisplayed: false,
  isSchoolMultiSelectDisplayed: false,
  isClusterDisplayed: false,
  isTeachersDisplayed: false,
  isSchoolYearDisplayed: false,
  isSelectDateRangeDisplayed: false,
  isStartDateDisplayed: false,
  isEndDateDisplayed: false,
  isSummarizeAtOrganizationDisplayed: false,
  isSummarizeAtLevelDisplayed: false,
  isIncludeInactiveUsersDisplayed: false,
  isIncludeNietAdministratorsDisplayed: false,
  isIncludeDirectorsDisplayed: false,
  isDataCollectionPeriodDisplayed: false,
  isDataCollectionPeriodMultiSelectDisplayed: false,
  isGroupByDisplayed: false,
  isGradeLevelDisplayed: false,
});
